<div class="main-content">
  <h2 mat-dialog-title>Change Password</h2>
<mat-dialog-content>
  <form>
    <mat-form-field>
      <mat-label>New Password</mat-label>
      <input matInput type="password"  [(ngModel)]="password1" required>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Confirm Password</mat-label>
      <input matInput type="password"  [(ngModel)]="password2" required>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="gts-btn-primary" mat-button (click)="onSubmit()">Change Password</button>
</mat-dialog-actions>
  <!-- <div></div>
  <div class="flex-container">
    <div class="container-width">
      <app-card-icon-title [icon]="icon"></app-card-icon-title>
          <div class="card">
          <div class="card-body ">
            <div class="tab-content tab-space">
              <div class="tab-pane active" id="link1">
                <form #userForm="ngForm" (ngSubmit)="onSubmit()">
                 
                  <div class="">
                      <div class="">
                        <div class="form-group">
                          <label class="bmd-label-floating">New password</label>
                          <input placeholder="********" type="password" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="password1" required>
                          </div>
                      </div>
                      <div class="">
                        <div class="form-group">
                          <label class="bmd-label-floating">Confirm Password</label>
                          <input placeholder="********" type="password" [ngModelOptions]="{standalone: true}" [(ngModel)]="password2" class="form-control">
                        </div>
                      </div>
                  </div>
                    <div class="alert alert-success" *ngIf="status_user == 'success'">
                    Password has been changed!
                  </div>

                  <div class="alert alert-danger" *ngIf="password1 != password2" >
                    Passwords don't match
                    </div>
                 <div>
                <button type="submit" class="btn btn-rose">Change password</button>
                </div>
                </form>
              </div>
             
              
          
               
            </div>
          </div>
        </div>
          <div class="card-body">
            <form>
            
              
              
              
              
              <div class="clearfix"></div>
            </form>
          </div>
    </div>
  </div> -->
</div>
